<template>
    <div class="ei-workspace">
        <div class="ei-workspace-tabs">
            <button
                type="button"
                class="ei-workspace-tab"
                :class="{ 'ei-workspace-tab--active': tab === 'data' }"
                @click="tab = 'data'"
            >
                <i class="fas fa-pen"></i> 데이터 입력
            </button>
            <button
                type="button"
                class="ei-workspace-tab"
                :class="{ 'ei-workspace-tab--active': tab === 'chart' }"
                @click="tab = 'chart'"
            >
                <i class="fas fa-chart-line"></i> 추이 분석 차트
            </button>
        </div>

        <section v-show="tab === 'data'" class="ei-workspace-panel">
            <EnIntDataInput
                ref="dataInput"
                :en-int-idx="enIntIdx"
                :master-api-state="masterApiState"
                :shared-calc-list-api-state="sharedCalcListApiState"
                :date-type="dateType"
                :date-value="dateValue"
                @saved="onDataSaved"
            />
        </section>

        <section v-if="tab === 'chart'" class="ei-workspace-panel">
            <EnIntDataTrendChart
                ref="trendChart"
                :en-int-idx="enIntIdx"
                :master-api-state="masterApiState"
                :shared-calc-list-api-state="sharedCalcListApiState"
                :date-type="dateType"
                :date-value="dateValue"
                :refresh-token="chartRefreshToken"
            />
        </section>
    </div>
</template>

<script>
import EnIntDataInput from "./EnIntDataInput.vue";
import EnIntDataTrendChart from "./EnIntDataTrendChart.vue";

export default {
    name: "EnIntDataWorkspace",
    components: { EnIntDataInput, EnIntDataTrendChart },
    props: {
        enIntIdx: { type: Number, required: true },
        masterApiState: {
            type: Object,
            default: () => ({ response: null, data: null, loading: false, error: "" }),
        },
        sharedCalcListApiState: {
            type: Object,
            default: () => ({ response: null, data: null, loading: false, error: "" }),
        },
        dateType: { type: String, required: true },
        dateValue: { type: Number, required: true },
    },
    data() {
        return {
            tab: "data",
            chartRefreshToken: 0,
        };
    },
    watch: {
        enIntIdx() {
            this.tab = "data";
            this.chartRefreshToken += 1;
        },
        tab(next) {
            if (next === "chart") {
                this.$nextTick(() => this.$refs.trendChart?.resize());
            }
        },
    },
    methods: {
        onDataSaved() {
            this.chartRefreshToken += 1;
            this.$emit("saved");
        },
    },
};
</script>

<style scoped>
.ei-workspace {
    display: flex;
    flex-direction: column;
    gap: 0;
    min-height: 0;
    height: 100%;
    padding: 0px 13px;
    overflow: hidden;
}

.ei-workspace-tabs {
    display: flex;
    flex-wrap: nowrap;
    gap: 0;
    margin: 0;
    padding: 0 2px;
    border-bottom: 1px solid rgba(226, 232, 240, 0.95);
    background: transparent;
    overflow: visible;
}

.ei-workspace-tab {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    justify-content: center;
    min-height: 36px;
    padding: 9px 12px 13px 12px;
    border-radius: 0;
    border: 0;
    position: relative;
    background: transparent;
    color: #64748b;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
    transition:
        color 0.14s ease,
        background-color 0.14s ease;
}

.ei-workspace-tab::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0px;
    width: 82%;
    height: 3px;
    /* 위쪽 코너만 라운드, 아래 좌/우 코너는 각지게 */
    border-radius: 999px 999px 0 0;
    background: rgba(14, 116, 144, 1);
    opacity: 0;
    box-shadow: 0 6px 18px rgba(14, 116, 144, 0.14);
    pointer-events: none;
}

.ei-workspace-tab i {
    color: inherit;
    font-size: 11px;
}

.ei-workspace-tab:hover {
    background: rgba(14, 116, 144, 0.06);
    color: #334155;
}

.ei-workspace-tab--active {
    background: transparent;
    color: #0e7490;
}

.ei-workspace-tab--active::after {
    opacity: 1;
}

.ei-workspace-panel {
    min-height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 8px 0px;
}

@media (max-width: 720px) {
    .ei-workspace-tabs {
        width: 100%;
    }

    .ei-workspace-tab {
        flex: 1;
        min-width: 0;
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>
